export const ActionTypes = {
  LOADING: "FACEBOOK_LOGIN_LOADING",
  ERROR: "FACEBOOK_LOGIN_ERROR",
  SUCCESS: "FACEBOOK_LOGIN_SUCCESS",
};
